module.exports = __webpack_public_path__ + "static/media/vignesh (Custom).27227228.png";